export default __webpack_public_path__ + "static/O0010-41a3a9e358931f0982ff910aaae624ad.png";